import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = ["Account Info", "Profile Info", "Upload Image"];

export default function HorizontalLinearStepper({ activeStep }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const getColor = () => {
            if (index < activeStep) return "#bf98ce";
            if (index === activeStep) return "#bf98ce";
            return "#9e9e9e";
          };

          return (
            <Step key={label}>
              <StepLabel
                StepIconProps={{
                  sx: {
                    color: `${getColor()} !important`,
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
